import React from "react";
import ReactDom from "react-dom";
import OutsideClickHandler from "react-outside-click-handler";
import Title from "../Title/Title";

const MODAL_STYLES = {
  position: "fixed",
  borderRadius: "4px",
  width: "55vw",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#FFF",
  paddingLeft: "50px",
  paddingRight: "50px",
  paddingBottom: "50px",
  paddingTop: "35px",
  zIndex: 1000,
};

const OVERLAY_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, .7)",
  zIndex: 1000,
};

export default function HistoricalModal({ open, children, onClose }) {
  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <div style={OVERLAY_STYLES} />
      <OutsideClickHandler onOutsideClick={() => onClose(false)}>
        <div style={MODAL_STYLES}>
          {/* <button
            style={{
              float: "right",
              marginTop: "20px",
              fontSize: "30px",
              padding: "0",
            }}
            className="btn "
            onClick={onClose}
          >
            &times;
          </button> */}
          <h3 style={{ marginBottom: "20px" }} className="text-center">
            Historical Spot
          </h3>
          {children}
        </div>
      </OutsideClickHandler>
    </>,
    document.getElementById("historicalPortal")
  );
}
